import { useContext } from 'react';
import { RcThemeContext } from './ThemeContext';
export var useThemeSwitcher = function () {
    var context = useContext(RcThemeContext);
    if (!context) {
        throw new Error('To use `useThemeSwitcher`, component must be within a RcThemeSwitcherProvider');
    }
    return context;
};
